// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4786":"157a710d","7667":"abf9b543"}[chunkId] + ".chunk.css";
};